import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/Button'
import { ThemeToggleButton } from '@/components/ui/ThemeToggleButton'
import { TooltipProvider } from '@/components/ui/Tooltip'
import PlaySmithLogo from '@/assets/play-smith-icon-color.svg'

type NavigationProps = {
	onLoginClick: () => void
}

export function Navigation({ onLoginClick }: NavigationProps) {
	const [scrolled, setScrolled] = useState(false)

	// Handle scroll for sticky nav
	useEffect(() => {
		const handleScroll = () => {
			setScrolled(window.scrollY > 20)
		}

		window.addEventListener('scroll', handleScroll)
		return () => window.removeEventListener('scroll', handleScroll)
	}, [])

	return (
		<TooltipProvider>
			<nav className={`landing-nav ${scrolled ? 'landing-nav-scrolled' : ''}`}>
				<div className="landing-nav-container">
					<Link to="/" className="landing-nav-logo">
						<img src={PlaySmithLogo} alt="" className="landing-nav-logo-icon" />
						<span className="landing-nav-logo-text">PlaySmith</span>
					</Link>

					<div className="landing-nav-links">
						<a href="#how-it-works" className="landing-nav-link">How It Works</a>
						<a href="#features" className="landing-nav-link">Features</a>
					</div>

					<div className="landing-nav-actions">
						<ThemeToggleButton />
						<button
							onClick={onLoginClick}
							className="landing-nav-signin"
						>
							Sign In
						</button>
						<Button
							variant="action"
							onClick={onLoginClick}
							className="landing-nav-cta"
						>
							Join the Waitlist
						</Button>
					</div>
				</div>
			</nav>
		</TooltipProvider>
	)
}
